export const appsTransformationLogsDatatable = "/apps/transformation_logs_datatable";
